// Central site config — for Jay Ambe Jyotish
export const site = {
  brand: {
    name: "Jay Ambe Jyotish",
    nameHi: "जय अम्बे ज्योतिष",
    tagline: "Vedic Astrology & Spiritual Guidance",
    taglineHi: "वैदिक ज्योतिष एवं आध्यात्मिक मार्गदर्शन",
    initials: "JA",
  },
  contact: {
    phone: "+91 99242 07025",
    whatsapp: "919924207025", // digits only for wa.me
    email: "jayambe9970@gmail.com",
    address:
      "Honey Palak Road, Near Gangeshwar Mahadev Mandir, Adajan, Surat, Gujarat, India.",
    hours: "Mon – Sun · 9:00 AM – 8:00 PM",
  },
  socials: {
    facebook: "#",
    instagram: "#",
    youtube: "#",
    twitter: "#",
  },
};

// ---------- SERVICES ---------- //
// Each service uses a unique, culturally-authentic Indian image (Pexels).
const IMG = {
  havan:
    "https://images.pexels.com/photos/37531063/pexels-photo-37531063.jpeg?auto=compress&cs=tinysrgb&w=1400", // Havan sacred fire ceremony setup
  couplePatrika:
    "https://images.pexels.com/photos/32153681/pexels-photo-32153681.jpeg?auto=compress&cs=tinysrgb&w=1400", // Indian couple traditional
  weddingHappy:
    "https://images.pexels.com/photos/20518451/pexels-photo-20518451.jpeg?auto=compress&cs=tinysrgb&w=1400", // Indian bride & groom traditional
  turbanFormal:
    "https://images.pexels.com/photos/11114960/pexels-photo-11114960.jpeg?auto=compress&cs=tinysrgb&w=1400", // Indian man in turban reading book in library (advocate/study look)
  priestRitual:
    "https://images.pexels.com/photos/13405691/pexels-photo-13405691.jpeg?auto=compress&cs=tinysrgb&w=1400", // Hindu priest sacred fire ritual
  turbanBusiness:
    "https://images.pexels.com/photos/15073761/pexels-photo-15073761.jpeg?auto=compress&cs=tinysrgb&w=1400", // Sikh businessman briefcase
  weddingOutdoor:
    "https://images.pexels.com/photos/17657612/pexels-photo-17657612.jpeg?auto=compress&cs=tinysrgb&w=1400", // Indian couple embracing outdoor wedding
  familyGroup:
    "https://images.pexels.com/photos/5163915/pexels-photo-5163915.jpeg?auto=compress&cs=tinysrgb&w=1400", // Joint family of five outdoors
  turbanSmiling:
    "https://images.pexels.com/photos/15073801/pexels-photo-15073801.jpeg?auto=compress&cs=tinysrgb&w=1400", // Smiling turbaned professional
  coupleIndoor:
    "https://images.pexels.com/photos/32060316/pexels-photo-32060316.jpeg?auto=compress&cs=tinysrgb&w=1400", // South Asian couple indoors
  natalChart:
    "https://images.pexels.com/photos/16504588/pexels-photo-16504588.jpeg?auto=compress&cs=tinysrgb&w=1400", // Indian student at university library, New Delhi
  turbanDowntown:
    "https://images.pexels.com/photos/15073808/pexels-photo-15073808.jpeg?auto=compress&cs=tinysrgb&w=1400", // Businessman downtown
  weddingJoy:
    "https://images.pexels.com/photos/32151000/pexels-photo-32151000.jpeg?auto=compress&cs=tinysrgb&w=1400", // Joyful Indian wedding ceremony
  couplePortrait:
    "https://images.pexels.com/photos/20738765/pexels-photo-20738765.jpeg?auto=compress&cs=tinysrgb&w=1400", // South Asian couple traditional
  familyPortrait:
    "https://images.pexels.com/photos/26244133/pexels-photo-26244133.jpeg?auto=compress&cs=tinysrgb&w=1400", // Indian father holding child with bindi
  priestsCeremony:
    "https://images.pexels.com/photos/37117232/pexels-photo-37117232.jpeg?auto=compress&cs=tinysrgb&w=1400", // Hindu priests in traditional ceremony
  coupleLaughing:
    "https://images.pexels.com/photos/19609201/pexels-photo-19609201.jpeg?auto=compress&cs=tinysrgb&w=1400", // Young Indian couple laughing indoors
  coupleFestive:
    "https://images.pexels.com/photos/27906415/pexels-photo-27906415.jpeg?auto=compress&cs=tinysrgb&w=1400", // Bride & groom traditional pose
};

export const services = [
  {
    key: "maha-mohini-vashikaran",
    title: "Maha Mohini Vashikaran",
    titleHi: "महा मोहिनी वशीकरण",
    desc: "Ancient tantric remedies to attract, influence and harmonise a specific person's energy toward you.",
    icon: "Sparkles",
    image: IMG.havan,
    long:
      "Maha Mohini Vashikaran is one of the most powerful branches of Vedic tantra — used only for pure, ethical intentions such as reuniting families, calming a partner's temperament, or gaining favourable attention. Jyotish ji performs authentic mantra-shakti rituals under strict discipline, always aligned with your birth chart.",
    benefits: [
      "Attract the sincere attention of a specific person",
      "Calm anger, jealousy or misunderstanding in relationships",
      "Restore emotional influence with dignity",
      "Confidential guidance rooted in classical tantra",
    ],
  },
  {
    key: "love-problem-specialist",
    title: "Love Problem Specialist",
    titleHi: "प्रेम समस्या विशेषज्ञ",
    desc: "Compassionate, chart-based guidance for love that feels distant, delayed or troubled.",
    icon: "Heart",
    image: IMG.couplePatrika,
    long:
      "Love, once bright, can dim due to karmic patterns, planetary dashas or Mangal-Rahu-Ketu disturbances. Jyotish ji reads both charts, identifies the exact root cause, and offers gentle remedies — mantras, fasts, gemstones — to rekindle trust, warmth and communication.",
    benefits: [
      "Compatibility analysis of both partners' charts",
      "Remedies for silence, distance and misunderstandings",
      "Guidance for committed and long-distance relationships",
      "Absolute confidentiality",
    ],
  },
  {
    key: "marriage-problem-solution",
    title: "Marriage Problem Solution",
    titleHi: "विवाह समस्या समाधान",
    desc: "Restore peace, romance and understanding in an existing marriage with time-tested Vedic remedies.",
    icon: "Gem",
    image: IMG.weddingHappy,
    long:
      "Every marriage moves through phases mirrored in the D-9 (Navamsa) chart. Whether the concern is emotional distance, in-law tension or financial stress, Jyotish ji identifies the specific graha disturbance and prescribes a practical plan — puja, mantra, fasting or gemstones — to bring the household back to harmony.",
    benefits: [
      "Deep D-9 Navamsa analysis of both partners",
      "Remedies for daily arguments and misunderstandings",
      "Guidance for in-law and joint-family harmony",
      "Rituals to reignite affection and intimacy",
    ],
  },
  {
    key: "court-cases-problem",
    title: "Court Cases Problem Solution",
    titleHi: "कोर्ट केस समाधान",
    desc: "Strategic astrological support for pending litigation, property disputes and legal setbacks.",
    icon: "Scale",
    image: IMG.turbanFormal,
    long:
      "The 6th, 8th and 12th houses govern legal battles. Jyotish ji examines the current dasha and transits impacting these houses, then advises supportive mantras, hearing-day muhurtas and specific gemstones that traditionally strengthen a rightful case.",
    benefits: [
      "Analysis of dasha and transits over 6th/8th/12th houses",
      "Auspicious muhurta for court hearings",
      "Mantras for Shani, Rahu and legal deities",
      "Guidance for property, criminal and civil matters",
    ],
  },
  {
    key: "breakup-problem-solution",
    title: "Breakup Problem Solution",
    titleHi: "ब्रेकअप समाधान",
    desc: "Heal, reflect, and — if the karmic bond permits — reunite with the one you have lost.",
    icon: "HeartCrack",
    image: IMG.priestRitual,
    long:
      "A breakup is often the surface reflection of a deeper karmic pattern. Jyotish ji studies your synastry chart, identifies whether the bond is meant to renew or transform, and prescribes healing rituals along with practical remedies to help you either reunite gracefully or move forward with peace.",
    benefits: [
      "Karmic-bond assessment via synastry",
      "Emotional healing mantras and rituals",
      "Guidance for reconciliation when auspicious",
      "Support for letting go with dignity",
    ],
  },
  {
    key: "business-problem-solution",
    title: "Business Problem Solution",
    titleHi: "व्यापार समस्या समाधान",
    desc: "Turn around stagnating business, unblock cashflow and choose partners with clarity.",
    icon: "TrendingUp",
    image: IMG.turbanBusiness,
    long:
      "Every business has a chart — the moment it was founded. Jyotish ji analyses partnership synastry, expansion timing, brand names and even office Vastu to help entrepreneurs grow steadily. Guidance blends numerology, muhurta and business acumen rooted in decades of practice.",
    benefits: [
      "Business chart and partnership compatibility",
      "Auspicious muhurta for launches and expansion",
      "Brand-name numerology and logo colour guidance",
      "Yearly business forecast and remedies",
    ],
  },
  {
    key: "husband-wife-problem",
    title: "Husband Wife Problem Solution",
    titleHi: "पति-पत्नी समस्या समाधान",
    desc: "Rebuild trust, tenderness and emotional intimacy between husband and wife.",
    icon: "Users",
    image: IMG.weddingOutdoor,
    long:
      "Distance between spouses is often not personal — it is planetary. Jyotish ji identifies the exact grahas causing friction (frequently Mars, Rahu or Moon afflictions) and offers a step-by-step remedy plan that respects both partners and can be practiced discreetly at home.",
    benefits: [
      "Root-cause analysis of daily conflicts",
      "Remedies for anger, doubt and infidelity fears",
      "Rituals to restore romance and intimacy",
      "Guided couple mantras",
    ],
  },
  {
    key: "family-problem-solution",
    title: "Family Problem Solution",
    titleHi: "पारिवारिक समस्या समाधान",
    desc: "Bring warmth back to a family strained by silence, disputes or generational conflict.",
    icon: "Home",
    image: IMG.familyGroup,
    long:
      "The 4th house holds the emotional health of the entire family. Jyotish ji studies the chart of each key member, identifies where planetary shadows are casting tension, and prescribes a unified family mantra, puja or Vastu correction to restore harmony under one roof.",
    benefits: [
      "Full-family chart and Vastu review",
      "Remedies for parent-child and sibling disputes",
      "Guidance for joint-family harmony",
      "Practical rituals that involve the whole home",
    ],
  },
  {
    key: "job-problem-solution",
    title: "Job Problem Solution",
    titleHi: "नौकरी समस्या समाधान",
    desc: "Overcome delays in placement, workplace politics and untimely job losses.",
    icon: "Briefcase",
    image: IMG.turbanSmiling,
    long:
      "The 10th house of profession is powerfully influenced by Saturn, Sun and the current mahadasha. Jyotish ji identifies exactly why your job hunt is delayed, or why office politics feel personal, and prescribes remedies to strengthen these grahas and open steady opportunity.",
    benefits: [
      "Root-cause reading of job delays or hostility",
      "Best muhurta for interviews and joining",
      "Mantras for Shani and Surya",
      "Gemstone guidance for career growth",
    ],
  },
  {
    key: "relationship-problem",
    title: "Relationship Problem Solution",
    titleHi: "रिश्ता समस्या समाधान",
    desc: "For any strained bond — friend, sibling or colleague — get clarity and a path forward.",
    icon: "HeartHandshake",
    image: IMG.coupleIndoor,
    long:
      "Not every relationship is romantic — yet all are governed by planetary rhythm. Jyotish ji reads the synastry between any two people (friends, partners, family, colleagues) and offers grounded, non-judgemental guidance to restore respect and clarity between you.",
    benefits: [
      "Synastry for any two individuals",
      "Practical, non-judgemental advice",
      "Remedies for repeated arguments or coldness",
      "Guided listening and communication rituals",
    ],
  },
  {
    key: "study-problem-solution",
    title: "Study Problem Solution",
    titleHi: "अध्ययन समस्या समाधान",
    desc: "Sharpen focus, memory and exam performance with time-honoured Vedic remedies.",
    icon: "BookOpen",
    image: IMG.natalChart,
    long:
      "The 4th house of study and 5th house of intelligence together shape a student's success. Jyotish ji strengthens weak Mercury or Jupiter placements through Saraswati mantras, gemstones and specific daily practices — helping students of every age focus, retain and perform under pressure.",
    benefits: [
      "Analysis of Mercury, Jupiter and Ketu placements",
      "Saraswati mantras and study rituals",
      "Muhurta selection for exams and admissions",
      "Guidance for higher studies and abroad options",
    ],
  },
  {
    key: "career-problem-solution",
    title: "Career Problem Solution",
    titleHi: "करियर समस्या समाधान",
    desc: "Identify the profession that truly resonates — and time your next move with the stars.",
    icon: "Award",
    image: IMG.turbanDowntown,
    long:
      "Your Dasamsha chart (D-10) reveals the professions where your soul thrives. Whether you are stuck in the wrong field, uncertain about a switch, or aspiring for a leap abroad, Jyotish ji reads your karmic career path and prescribes remedies to unblock stagnation.",
    benefits: [
      "Best-fit career streams from your D-10 chart",
      "Optimal timing for job change or promotion",
      "Guidance for higher studies and foreign opportunities",
      "Remedies to unblock stagnation",
    ],
  },
  {
    key: "love-marriage-specialist",
    title: "Love Marriage Specialist",
    titleHi: "प्रेम विवाह विशेषज्ञ",
    desc: "For couples in love and facing family resistance — turn hearts, and choose the right muhurta.",
    icon: "Gem",
    image: IMG.weddingJoy,
    long:
      "Love marriage brings its own delicate combination of family, community and planetary permission. Jyotish ji reads both charts, examines Manglik, Nadi and Bhakoot doshas, and prescribes remedies that soften parental hesitation — followed by muhurta selection for a blessed wedding day.",
    benefits: [
      "Compatibility (Guna Milan) for the couple",
      "Remedies for parental and family resistance",
      "Auspicious muhurta selection",
      "Manglik and dosha nivaran rituals",
    ],
  },
  {
    key: "get-your-love-back",
    title: "Get Your Love Back",
    titleHi: "खोया प्यार वापस पाएं",
    desc: "Reunite with the one you love through ethical, chart-based mantras and rituals.",
    icon: "Heart",
    image: IMG.couplePortrait,
    long:
      "If the karmic bond permits, a lost love can return — softly, on its own terms. Jyotish ji reads the synastry of your relationship, identifies whether reunion is auspicious, and if yes, prescribes specific mantras, fasts and rituals to gently re-open your beloved's heart.",
    benefits: [
      "Karmic reunion assessment via synastry",
      "Ethical Vashikaran or mantra remedies",
      "Guidance to approach with dignity and patience",
      "Ongoing support through the reconciliation phase",
    ],
  },
  {
    key: "child-problem-solution",
    title: "Child Problem Solution",
    titleHi: "संतान समस्या समाधान",
    desc: "For couples awaiting a child or worried about a child's health, studies or behaviour.",
    icon: "Sparkles",
    image: IMG.familyPortrait,
    long:
      "The 5th house governs children, creativity and the joy they bring. Whether the concern is delay in childbirth, a child's stubbornness, or health issues, Jyotish ji reads the 5th-house chart of both parents and prescribes Santan Gopal rituals along with practical remedies.",
    benefits: [
      "Analysis of 5th-house influences for both parents",
      "Santan Gopal mantras and rituals",
      "Guidance for child's studies and behaviour",
      "Remedies for delayed conception",
    ],
  },
  {
    key: "divorce-problem-solution",
    title: "Divorce Problem Solution",
    titleHi: "तलाक समस्या समाधान",
    desc: "Whether you seek reconciliation or a peaceful separation, choose the path with clarity.",
    icon: "Scale",
    image: IMG.priestsCeremony,
    long:
      "Divorce is one of life's heaviest passages. Jyotish ji offers a private, non-judgemental sitting to read whether the marriage can still be healed, or whether it is karmically time to part. In either case, mantras, rituals and legal muhurta guidance are provided.",
    benefits: [
      "Honest karmic assessment of the marriage",
      "Reconciliation rituals if auspicious",
      "Muhurta for peaceful legal proceedings",
      "Emotional healing mantras for both partners",
    ],
  },
  {
    key: "gf-bf-problem",
    title: "GF/BF Problem Solution",
    titleHi: "प्रेमी/प्रेमिका समस्या समाधान",
    desc: "For unmarried couples facing distance, doubt, jealousy or interference from others.",
    icon: "HeartHandshake",
    image: IMG.coupleLaughing,
    long:
      "Young love faces its own tests — long distance, family objection, jealousy, third-party interference. Jyotish ji reads both charts with a modern, non-judgemental lens and offers practical remedies to steady the bond until it is ready to be formalised.",
    benefits: [
      "Youth-friendly, non-judgemental guidance",
      "Remedies for jealousy and interference",
      "Long-distance relationship support",
      "Preparation for meeting each other's families",
    ],
  },
  {
    key: "intercaste-marriage",
    title: "Intercaste Marriage Problem",
    titleHi: "अंतरजातीय विवाह समाधान",
    desc: "For couples in love across caste or community lines — soften resistance and unite hearts.",
    icon: "Users",
    image: IMG.coupleFestive,
    long:
      "An intercaste bond often requires more than compatibility — it requires acceptance. Jyotish ji reads both charts, prescribes mantras and rituals to soften family resistance, and offers ongoing counsel through the delicate process of bringing two families into one.",
    benefits: [
      "Compatibility and Guna Milan for the couple",
      "Rituals to soften family resistance",
      "Guidance for community-related concerns",
      "Muhurta selection and post-wedding harmony",
    ],
  },
];

export const whyChoose = [
  {
    title: "25+ Years of Experience",
    desc: "Guiding thousands of families with authentic Vedic wisdom passed down through generations.",
    icon: "Award",
  },
  {
    title: "Authentic Vedic Methods",
    desc: "Rooted in classical texts — Parashari, Jaimini and Nadi systems, applied with care.",
    icon: "BookOpen",
  },
  {
    title: "Confidential & Compassionate",
    desc: "Every consultation is private, judgment-free, and devoted to your true well-being.",
    icon: "ShieldCheck",
  },
  {
    title: "Effective Remedies",
    desc: "Practical mantras, rituals and gemstone guidance you can integrate into daily life.",
    icon: "Sparkles",
  },
  {
    title: "Global Consultations",
    desc: "In-person, phone and video sessions available for seekers around the world.",
    icon: "Globe",
  },
  {
    title: "10,000+ Happy Seekers",
    desc: "A trusted community of clients whose lives have been transformed with clarity.",
    icon: "Users",
  },
];

export const testimonials = [
  {
    name: "Ananya Sharma",
    location: "Mumbai, IN",
    quote:
      "Jyotish ji's birth-chart reading felt like meeting my truest self. His remedies were simple yet transformative — my career doubts vanished within months.",
    stars: 5,
  },
  {
    name: "Rohan Mehta",
    location: "London, UK",
    quote:
      "I consulted him for marriage compatibility. The clarity and warmth in his session gave our family the confidence to move forward with peace.",
    stars: 5,
  },
  {
    name: "Priya Nair",
    location: "Bengaluru, IN",
    quote:
      "The Vastu suggestions for our new home changed the entire energy. My children sleep better and our business has grown steadily.",
    stars: 5,
  },
  {
    name: "Vikram Desai",
    location: "Dubai, UAE",
    quote:
      "Genuine, grounded and deeply spiritual. He never overpromises — only guides. That honesty is rare and priceless.",
    stars: 5,
  },
  {
    name: "Sneha Kulkarni",
    location: "Pune, IN",
    quote:
      "The numerology consultation reshaped our brand name and everything shifted. Grateful beyond words for Jyotish ji's wisdom.",
    stars: 5,
  },
  {
    name: "Arjun Patel",
    location: "Ahmedabad, IN",
    quote:
      "Meeting Jay Ambe Jyotish gave my family a sense of direction. His words carry the calm of the temples I grew up in.",
    stars: 5,
  },
];

export const faqs = [
  {
    q: "How is a consultation conducted?",
    a: "Consultations happen in-person at our Surat office or via video call, phone and WhatsApp. You will receive a birth-chart-based reading followed by a personalised remedy plan.",
  },
  {
    q: "What details do I need to share before booking?",
    a: "Please share your exact date, time, and place of birth. For relationship, marriage or business questions, we may request the same details of the concerned person.",
  },
  {
    q: "Are the remedies suggested affordable?",
    a: "Absolutely. Most remedies are prayer, mantra or lifestyle based. Gemstone or ritual recommendations, when suggested, come with clear cost estimates upfront.",
  },
  {
    q: "क्या मुझे परिणाम की गारंटी मिलेगी?",
    a: "ज्योतिष एक मार्गदर्शक विज्ञान है, चमत्कार नहीं। हम आपको स्पष्ट दिशा और उपचार देते हैं; निष्ठा और धैर्य से परिणाम अवश्य दिखते हैं।",
  },
  {
    q: "Do you offer online consultation reports?",
    a: "Yes. Detailed written consultation reports in English or Hindi can be delivered digitally within 5–7 working days of booking.",
  },
  {
    q: "Is my personal information confidential?",
    a: "Every consultation is strictly confidential. Your details are never shared with third parties under any circumstance.",
  },
];
